import React, {useState} from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {Link, useLocation} from "react-router-dom";
import {useDispatch} from "react-redux";


export default function EnquiryView() {
    const {instance} = useMsal();
    const account = useAccount();
    const dispatch = useDispatch()

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    let job = useLocation().state

    function DisplayVehicleInfo(props) {
        const numberVehicles = parseInt(job.enquiry.numberOfVehicles);
        const returnInfo = [];


        if (numberVehicles === 0) {
            returnInfo.push(
                <div>
                    No information about vehicles was provided.
                </div>
            )
        } else {
            for (const key in job.vehicles) {
                if (job.vehicles.hasOwnProperty(key)) {
                    returnInfo.push(
                        <div>
                            <div className=" vehicle-section">
                                <div className="comment-section">
                                    <p className="mb-0"> Comments:</p>
                                    <p> {job.vehicles[key].comments}</p>
                                </div>

                                <h3 className="list-section-header"> {job.vehicles[key].make}, {job.vehicles[key].model} :</h3>
                                <p className="info-section text-secondary"> Licence
                                    Plate: {job.vehicles[key].licencePlate} </p>
                                <p className="info-section text-secondary "> ID:#{job.vehicles[key].id} </p>

                                <br/> <br/> <br/>
                            </div>
                            <br/>
                        </div>
                    )
                }
            }
        }

        return returnInfo;
    }


    const [newJob, updateJob] = useState(job);


    function approve() {

        dispatch({type: 'updateInfo/Enquiries', payload: "APPROVED"})
 
        updateJob(newJob => {
            newJob.adminStatus = "APPROVED";
        });
    
    }



    function ApproveRequest(props) {
        const status = job.adminStatus; //(job.vehicles).length;         

        if (status === "UNAPPROVED") {
            return (
                <div>
                    <div className="list-section">
                        <h3>Approve customer request</h3>
                        <hr/>
                        <br/>

                        <Link to="/management/admin/view" className="btn btn-primary" onClick={approve} state={job}>
                            Approve Request
                            <log/>
                        </Link>
                    </div>


                    <div className="page-break"></div>
                </div>
            )
        }
    }

    function EnquiryApproved(props) {
        const status = job.adminStatus; //(job.vehicles).length;         

        if (status === "APPROVED") {
            return (
                <div>
                    <p>Enquiry approved: {job.dates.enquiryApproved}</p>
                </div>
            )
        }
    }


    return (
        <div>

            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>

                <div className="page-title-sh26">
                    <h1> Enquiry Details for {job.enquiry.companyName} </h1>
                    <p>Enquiry View for {job.enquiry.customerName} #{job.id}</p>
                </div>
                <hr/>

                <div className="page-break"></div>
                <div className="list-section">
                    <h3> Enquiry Details</h3>
                    <hr/>
                    <p>Company name: {job.enquiry.companyName} </p>
                    <p>Customer name: {job.enquiry.customerName} </p>
                    <p>Customer email: {job.enquiry.customerEmail} </p>
                    <p>Customer phone number: {job.enquiry.phoneNumber} </p>
                    <p>Message: {job.enquiry.message} </p>

                    <br/>
                    {/* These should maybe be smaller than the rest of the text? */}
                    <p>Enquiry recieved: {job.dates.enquiryReceived.toLocaleString().slice(0, 10)} </p>

                    <EnquiryApproved/>


                </div>

                <div className="page-break"></div>

                <div className="list-section">
                    <h3> Vehicle Details</h3>
                    <hr/>
                    <br/>
                    <DisplayVehicleInfo/>
                </div>

                <div className="page-break"></div>

                <div>
                    <ApproveRequest/>
                </div>


            </AuthenticatedTemplate>
        </div>
    );

}
